module.exports = __webpack_public_path__ + "static/media/dax.fa7fecb6.png";